import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Hammer from 'react-hammerjs'

import {
  FETCH_PROJECT,
  UPDATE_PROJECT_STARTED,
  SELECT_INDEX_TYPE,
  CREATE_QUESTION,
  DELETE_QUESTION,
  UPDATE_ALL_QUESTIONS,
  CHANGE_PROJECT_TITLE,
  SHOW_QUIZ_START_MODAL,
  HIDE_QUIZ_START_MODAL,
  SHOW_IMAGE_UPLOAD_MODAL,
  HIDE_IMAGE_UPLOAD_MODAL,
  SHOW_EDITOR_HEADER_MENU,
  HIDE_EDITOR_HEADER_MENU,
  LOG_OUT,
  RESET_PROJECT,
  GET_RANKING_DATA,
  GET_IS_FETCHABLE_RANKING_DATA
} from '../../actions/editorActions'
import EditorInput from '../../components/organisms/EditorInput/EditorInput'
import MobileEditorHeader from '../../components/organisms/mobile/MobileEditorHeader/MobileEditorHeader'
import SpinnerWithLabel from '../../components/molecules/SpinnerWithLabel/SpinnerWithLabel'
import './MobileEditorPage.css'
import { LP_IMAGE_URL } from '../../../commons/Const'
import ModalError from '../../components/organisms/ModalError/ModalError'
import MobileEditorPreviewSlider from '../../components/organisms/mobile/MobileEditorPreviewSlider/MobileEditorPreviewSlider'
import Editortimer from '../../components/molecules/EditorTimer/EditorTimer'
import Button from '../../components/atoms/Button/Button'
import { QuizType } from '../../../commons/EditorStatus'
import { noticeQuizStartToSlack } from '../../../commons/Slack'
import { Plan } from '../../../commons/Plan'

const FOCUSED_UPPER_PX = 150
const FOCUSED_BORDER_PX = 50

class MobileEditorPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inputFocused: false,
      deltaY: 0
    }
    this.slider = React.createRef()
  }
  componentDidMount() {
    this.props.fetchProject()
  }
  handlePan(e) {
    this.setState({
      deltaY: e.deltaY
    })
  }
  handlePanEnd() {
    if (this.state.deltaY < -FOCUSED_BORDER_PX) {
      this.setState({
        deltaY: -FOCUSED_UPPER_PX,
        inputFocused: true
      })
    } else if (this.state.deltaY > FOCUSED_BORDER_PX) {
      this.setState({
        deltaY: 0,
        inputFocused: false
      })
    } else {
      this.setState({
        deltaY: this.state.inputFocused ? -FOCUSED_UPPER_PX : 0
      })
    }
  }
  handleClickOverlay() {
    this.setState({
      deltaY: 0,
      inputFocused: false
    })
  }
  calculateOverlayOpacity() {
    const { deltaY, inputFocused } = this.state

    if (inputFocused) {
      if (deltaY <= 0) {
        return 1
      }

      if (deltaY >= FOCUSED_UPPER_PX) {
        return 0
      }

      return (FOCUSED_UPPER_PX - deltaY) / FOCUSED_UPPER_PX
    }

    // 編集画面がfocusされていない状態
    if (deltaY >= 0) {
      return 0
    }

    if (deltaY <= -FOCUSED_UPPER_PX) {
      return 1
    }

    return deltaY / -FOCUSED_UPPER_PX
  }

  handleAddQuestion() {
    const { project, addQuestion } = this.props
    addQuestion({ projectId: project.id, newIndex: project.questions.length + 1 })
    this.slider.current.slideTo(project.questions.length + 1)
  }

  handleDeleteQuestion(data) {
    if (!window.confirm('この問題を削除しますか？')) {
      return
    }
    const { project, deleteQuestion } = this.props

    const targetIndex = project.questions.findIndex(question => question.id === data.questionId)
    deleteQuestion(data)

    // 最後の問題を削除した場合、結果発表のスライドにcurrentがいかないようにする。まだproject.questionsの削除は反映されていない
    if (targetIndex === project.questions.length - 1) {
      this.slider.current.slideTo(targetIndex)
    }
  }

  render() {
    const {
      project,
      currentEditIndex,
      editorIndex,
      quizType,
      changeProjectTitle,
      canIntervalUpdate,
      updateAllQuestions,
      showImageUploadModal,
      selectIndexAndType,
      hideImageUploadModal,
      showQuizStartModal,
      hideQuizStartModal,
      isImageUploadModalShow,
      imageUploadTargetIndex,
      isLoading,
      lastUpdatedAt,
      isQuizStartModalShow,
      errorMessage,
      updateProjectStarted,
      resetProject,
      memberId,
      getRankingData,
      getIsFetchableRankingData,
      isFetchableRankingData
    } = this.props

    if (!project) {
      return (
        <div styleName="spinner">
          <SpinnerWithLabel />
        </div>
      )
    }

    let indexTitle = `第${currentEditIndex + 1}問`
    let sliderCurrentIndex = currentEditIndex + 1
    if (quizType === QuizType.FIRSTPAGE.value) {
      indexTitle = '表紙'
      sliderCurrentIndex = 0
    } else if (quizType === QuizType.RANKING.value) {
      indexTitle = '結果発表'
      sliderCurrentIndex = project.questions.length + 1
    }

    const handleChangeProjectStarted = started => {
      updateProjectStarted({
        started,
        id: project.id
      })
    }

    const handleClickOpenPresentationWindow = () => {
      if (
        window.confirm(
          '前回の参加者のデータをリセットしますか？\n\n参加者の名前、回答、スライドの進行状況をリセットできます。登録済の参加者の名前や回答ランキングのデータを残したい場合は「キャンセル」を選んでください。'
        )
      ) {
        resetProject()
        if (process.env.STAGE === 'production') {
          noticeQuizStartToSlack(
            '#notify_events',
            memberId,
            project.id,
            Plan.info(project.plan).name,
            'リセットした',
            project.project_title,
            project.presentation_title
          )
        }
        return
      }
      window.open('presentation', 'presentation', 'width=960,height=720')
      if (process.env.STAGE === 'production') {
        noticeQuizStartToSlack(
          '#notify_events',
          memberId,
          project.id,
          Plan.info(project.plan).name,
          'リセットしていない',
          project.project_title,
          project.presentation_title
        )
      }
    }

    const handleDownloadRankingData = () => {
      if (window.confirm('ランキングデータをダウンロードしますか？')) {
        getRankingData(project.id)
      }
    }

    const handleShowQuizModal = () => {
      getIsFetchableRankingData(project.id)
      showQuizStartModal()
    }

    return (
      <div styleName="container">
        <div styleName="background" />
        <MobileEditorHeader
          projectTitle={project.project_title}
          onChangeProjectTitleText={changeProjectTitle}
          shareParam={project.share_param}
          isModalShow={isQuizStartModalShow}
          showModal={handleShowQuizModal}
          hideModal={hideQuizStartModal}
          plan={project.plan}
          isStarted={project.is_started}
          expireDate={project.expire_date}
          handleChangeProjectStarted={handleChangeProjectStarted}
          handleClickOpenPresentationWindow={handleClickOpenPresentationWindow}
          handleDownloadRankingData={handleDownloadRankingData}
          handleReadyRankingData={getIsFetchableRankingData}
          isFetchableRankingData={isFetchableRankingData}
        />
        <div styleName="info">
          <div styleName="space" />
          <p styleName="index">{indexTitle}</p>
          <div styleName="addButton">
            <Button handleClick={() => this.handleAddQuestion()}>
              <p styleName="addButtonText">問題を追加</p>
            </Button>
          </div>
        </div>
        <div styleName="previewSlider">
          <MobileEditorPreviewSlider
            ref={this.slider}
            questions={project.questions}
            eventTitle={project.presentation_title}
            eventImage={project.image || LP_IMAGE_URL}
            handleChangeIndex={selectIndexAndType}
            currentIndex={sliderCurrentIndex}
          />
        </div>
        {this.state.deltaY >= 0 && !this.state.inputFocused ? null : (
          <div
            styleName="overlay"
            onClick={() => this.handleClickOverlay()}
            style={{ opacity: this.calculateOverlayOpacity() }}
          />
        )}

        <Hammer onPan={e => this.handlePan(e)} onPanEnd={() => this.handlePanEnd()} direction="DIRECTION_VERTICAL">
          <div styleName="editor" style={{ transform: `translate(0px, ${this.state.deltaY}px)` }}>
            <EditorInput
              project={project}
              answers={project.questions[currentEditIndex].choices}
              rankingConfig={project.ranking_count}
              quizType={quizType}
              currentEditIndex={currentEditIndex}
              editorIndex={editorIndex}
              imageUploadTargetIndex={imageUploadTargetIndex}
              showImageUploadModal={showImageUploadModal}
              hideImageUploadModal={hideImageUploadModal}
              isModalShow={isImageUploadModalShow}
              handleDeleteQuestion={data => this.handleDeleteQuestion(data)}
            />
          </div>
        </Hammer>
        <Editortimer
          isEnabled={canIntervalUpdate}
          timerFunction={updateAllQuestions}
          lastUpdateTime={lastUpdatedAt || project.updated_at}
        />
        {isLoading ? (
          <div styleName="loadingOverlay">
            <div styleName="loadingPopup">
              <SpinnerWithLabel />
            </div>
          </div>
        ) : null}
        {errorMessage ? <ModalError message={errorMessage} /> : null}
      </div>
    )
  }
}

MobileEditorPage.propTypes = {
  project: PropTypes.object,
  currentEditIndex: PropTypes.number,
  editorIndex: PropTypes.number,
  fetchProject: PropTypes.func,
  resetProject: PropTypes.func,
  updateProjectStarted: PropTypes.func.isRequired,
  selectIndexAndType: PropTypes.func.isRequired,
  quizType: PropTypes.number,
  addQuestion: PropTypes.func.isRequired,
  deleteQuestion: PropTypes.func.isRequired,
  updateAllQuestions: PropTypes.func.isRequired,
  canIntervalUpdate: PropTypes.bool.isRequired,
  changeProjectTitle: PropTypes.func.isRequired,
  showQuizStartModal: PropTypes.func.isRequired,
  hideQuizStartModal: PropTypes.func.isRequired,
  showImageUploadModal: PropTypes.func.isRequired,
  hideImageUploadModal: PropTypes.func.isRequired,
  isQuizStartModalShow: PropTypes.bool.isRequired,
  isImageUploadModalShow: PropTypes.bool.isRequired,
  imageUploadTargetIndex: PropTypes.number.isRequired,
  isEditorHeaderMenuShow: PropTypes.bool.isRequired,
  showEditorHeaderMenu: PropTypes.func.isRequired,
  hideEditorHeaderMenu: PropTypes.func.isRequired,
  lastUpdatedAt: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  handleLogOut: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  memberId: PropTypes.number,
  getRankingData: PropTypes.func.isRequired,
  getIsFetchableRankingData: PropTypes.func.isRequired,
  isFetchableRankingData: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    project: state.editor.project,
    currentEditIndex: state.editor.currentEditIndex,
    editorIndex: state.editor.editorIndex,
    quizType: state.editor.quizType,
    canIntervalUpdate: state.editor.canIntervalUpdate,
    isQuizStartModalShow: state.editor.isQuizStartModalShow,
    isImageUploadModalShow: state.editor.isImageUploadModalShow,
    isEditorHeaderMenuShow: state.editor.isEditorHeaderMenuShow,
    imageUploadTargetIndex: state.editor.imageUploadTargetIndex,
    lastUpdatedAt: state.editor.lastUpdatedAt,
    isLoading: state.editor.isLoading,
    errorMessage: state.editor.errorMessage,
    memberId: state.auth.currentUserId,
    isFetchableRankingData: state.editor.isFetchableRankingData
  }
}
const mapDispatchToProps = dispatch => ({
  fetchProject: () => dispatch(FETCH_PROJECT()),
  resetProject: () => dispatch(RESET_PROJECT()),
  updateProjectStarted: params => dispatch(UPDATE_PROJECT_STARTED(params)),
  selectIndexAndType: (index, type) => dispatch(SELECT_INDEX_TYPE({ index: index, type: type })),
  addQuestion: data => dispatch(CREATE_QUESTION(data)),
  deleteQuestion: data => dispatch(DELETE_QUESTION(data)),
  changeProjectTitle: text => dispatch(CHANGE_PROJECT_TITLE(text)),
  updateAllQuestions: () => dispatch(UPDATE_ALL_QUESTIONS()),
  showQuizStartModal: () => dispatch(SHOW_QUIZ_START_MODAL()),
  hideQuizStartModal: () => dispatch(HIDE_QUIZ_START_MODAL()),
  showImageUploadModal: target => dispatch(SHOW_IMAGE_UPLOAD_MODAL(target)),
  hideImageUploadModal: target => dispatch(HIDE_IMAGE_UPLOAD_MODAL(target)),
  showEditorHeaderMenu: () => dispatch(SHOW_EDITOR_HEADER_MENU()),
  hideEditorHeaderMenu: () => dispatch(HIDE_EDITOR_HEADER_MENU()),
  handleLogOut: () => dispatch(LOG_OUT()),
  getRankingData: data => dispatch(GET_RANKING_DATA(data)),
  getIsFetchableRankingData: data => dispatch(GET_IS_FETCHABLE_RANKING_DATA(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileEditorPage)
